import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionState } from 'src/app/enums/action-state.enum';
import { NetworkRepo } from 'src/app/repositories/network-repo';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { ApplicationFeature } from 'src/swagger-gen/web-secured/models';
import { DataAfterCloseStationsModal } from './models/dataAfterCloseStationsModal';

@Component({
    selector: 'app-modal-stations',
    templateUrl: './modal-stations.component.html',
    styleUrls: ['./modal-stations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalStationsComponent implements OnInit {

  FEATURE = ApplicationFeature;

  // downloadFile
  backendResponseDownloadedFile: any = null;
  backendResponseDownloadedFileStations: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;
  backendResponseUploadedFileStations: any = null;

  constructor(
    private networkRepo: NetworkRepo,
    private stationRepo: StationsRepo,
    @Inject(MAT_DIALOG_DATA) public data: DataAfterCloseStationsModal) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseStationsModal();
  }


  onUserWantsDownloadEvent(event: boolean): void {
    if (event) {
      this.downloadFile();
    }
  }

  onUserWantsUploadEvent(file: any): void {
    if (file) {
      this.uploadFile(file);
    }
  }

  onUserWantsDownloadStationsEvent(event: boolean): void {
    if (event) {
      this.downloadStationsFile();
    }
  }

  onUserWantsUploadStationsEvent(file: any): void {
    if (file) {
      this.uploadStationsFile(file);
    }
  }



  downloadFile(): void {
    this.networkRepo.exportNetworkDefinition().toPromise()
    .then((response) => {
      this.backendResponseDownloadedFile = response;
    })
    .catch((err) => {
      this.backendResponseDownloadedFile = err;
    });
  }

  uploadFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    this.networkRepo.importNetworkDefinition(file).toPromise()
    .then((response) => {
      this.backendResponseUploadedFile = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFile = err;
      this.data.uploadFileState = ActionState.FAILED;
    });
  }



  downloadStationsFile(): void {
    this.stationRepo.exportStationDefinition().toPromise()
    .then((response) => {
      this.backendResponseDownloadedFileStations = response;
    })
    .catch((err) => {
      this.backendResponseDownloadedFileStations = err;
    });
  }

  uploadStationsFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    this.stationRepo.importStationDefinition(file).toPromise()
    .then((response) => {
      this.backendResponseUploadedFileStations = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFileStations = err;
      this.data.uploadFileState = ActionState.FAILED;
    });
  }
}
